import { render } from "./CommentMaker.vue?vue&type=template&id=ec52879c&scoped=true"
import script from "./CommentMaker.vue?vue&type=script&lang=js"
export * from "./CommentMaker.vue?vue&type=script&lang=js"

import "./CommentMaker.vue?vue&type=style&index=0&id=ec52879c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator.1LIZRQUYRIVXOVB\\github-classroom\\MUICCS\\cs340prj-Atiwat-R\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec52879c"]])

export default __exports__